export const PRODUCT_CATALOGUE = '/Catalog/GetProductCatalogue';